import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Tabel Data NPWP", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Tabel Data NPWP", -1)
const _hoisted_6 = {
  style: {"text-align":"right"},
  class: "mt-5"
}
const _hoisted_7 = { class: "d-flex px-8 mt-5" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex mx-9 position-relative"
}
const _hoisted_9 = { class: "d-flex px-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-8" }
const _hoisted_12 = {
  class: "row",
  style: {"margin-left":"10px"}
}
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "card-body py-3" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sales"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status NPWP"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor NPWP"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Foto NPWP"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = {
  key: 0,
  class: "text-center"
}
const _hoisted_23 = {
  key: 1,
  class: "text-center"
}
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = {
  key: 2,
  class: "text-center"
}
const _hoisted_26 = {
  key: 3,
  class: "text-center"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/download.svg",
  alt: ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "row mt-5 mb-5" }
const _hoisted_38 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_39 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_40 = ["label", "value"]
const _hoisted_41 = { class: "p-3" }
const _hoisted_42 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_43 = { class: "pagination" }
const _hoisted_44 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_edit"
}
const _hoisted_45 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_46 = { class: "modal-content rounded" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, "Detail NPWP"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_48 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-xl-6 mb-8" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Nama Sekolah", -1)
const _hoisted_52 = { class: "col-xl-6 mb-8" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Status NPWP", -1)
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-xl-6 mb-8" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Sales", -1)
const _hoisted_57 = { class: "col-xl-6 mb-8" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Nomor NPWP", -1)
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-xl-6 mb-8" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Email PIC", -1)
const _hoisted_62 = { class: "col-xl-6 mb-8" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Nomor Telepon", -1)
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-xl-6 mb-8" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Email", -1)
const _hoisted_67 = { class: "col-lg-6 fv-row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Input NPWP", -1)
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-xl-12 mb-8" }
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              style: {"cursor":"pointer"},
              "data-bs-target": "#kt_modal_3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getDownloadAll && _ctx.getDownloadAll(...args)))
            }, " Download ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light",
          style: {"font-weight":"400","margin-top":"0px"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
        }, " Filter "),
        (_ctx.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.schoolId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolId) = $event)),
                      placeholder: "Pilih Sekolah",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listSekolah,
                      searchable: true,
                      label: "name",
                      "track-by": "name",
                      "value-prop": "_id",
                      "max-height": 350,
                      max: 5,
                      style: {"width":"600px"},
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihSekolah($event)))
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.confirmation,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmation) = $event)),
                      placeholder: "Pilih Status Konfirmasi",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listConfirmation,
                      searchable: true,
                      label: "label",
                      "track-by": "label",
                      "value-prop": "value",
                      "max-height": 350,
                      max: 5,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sorting($event)))
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _hoisted_17,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(item.salesAreaName), 1),
                      (item.npwpStatus == true)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString("Sudah")))
                        : (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString("Belum"))),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(item.npwpNumber), 1),
                      (item.npwpImageUrl == '')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString("Tidak Tersedia")))
                        : (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString("Tersedia"))),
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          title: "Download",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (
                      _ctx.getDownloadById(item._id, item.npwpImageUrl, item.name)
                    )
                        }, _hoisted_30, 8, _hoisted_28),
                        (_ctx.roleuser !== 'CS_LEADER' && _ctx.roleuser !== 'CS_MEMBER')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "symbol symbol-35px me-2",
                              title: "Edit",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.getId(item._id, item.npwpStatus)),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_edit"
                            }, _hoisted_33, 8, _hoisted_31))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_34, _hoisted_36))
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_40))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("ul", _hoisted_43, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "nama_sekolah",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.name,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formDetail.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "status_npwp",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.setatus,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.setatus) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "sales_area_name",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.salesAreaName,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formDetail.salesAreaName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "nomor_npwp",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.npwp.number,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.npwp.number) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "sales_area_name",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.picEmail,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formDetail.picEmail) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "nomor_npwp",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.picPhone,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formDetail.picPhone) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "sales_area_name",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.email,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formDetail.email) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _createElementVNode("input", {
                class: "form-control form-control-lg",
                name: "file",
                type: "file",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleFileUpload($event, _ctx.formDetail._id))),
                placeholder: "Upload File NPWP",
                accept: "image/*"
              }, null, 32),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_ErrorMessage, { name: "imageUrl" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("img", {
                  alt: "img",
                  class: "pl-3",
                  style: {"max-width":"300px"},
                  src: _ctx.foto
                }, null, 8, _hoisted_73)
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("button", {
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
                type: "button",
                class: "btn btn-danger",
                "data-bs-dismiss": "modal",
                style: {"background-color":"#e50200"}
              }, " Batal "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveNpwp(_ctx.image, _ctx.formDetail._id)))
              }, " Simpan ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}